import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-gpx";
import { useTranslation } from "react-i18next";
import useWindowDimension from "../../../components/hooks/useWindowDimension";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CustomToggleButton from "../../../components/customToggleButton/customToggleButton";
import CustomButton from "../../../components/customButton/customButton";
import "./trailDetail.scss";
import { showToast } from "../../../store/features/toast/toastSlice";
import Constant from "../../../util/constant";
import { Carousel, CarouselItem, CarouselIndicators } from "reactstrap";
import { useLocation } from "react-router-dom";
import axios from "axios";
import imagePlaceholder from "../../../assets/images/tottPlaceholder.svg";
import "leaflet-fullscreen";
import "leaflet-fullscreen/dist/leaflet.fullscreen.css";
import { TRAILS_EDIT, TRAILS_STATUS } from "../../../api/endPoint";
import { getCloudinaryOtherImageUrl } from "../../../util/cloudinaryUpload";
import { Helmet } from "react-helmet";

declare module "leaflet" {
  interface MapOptions {
    fullscreenControl?: boolean;
  }

  namespace control {
    function fullscreen(options?: {
      position?: string;
      title?: { false: string; true: string };
    }): Control;
  }
}

const TrailDetail: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const trailData = location?.state?.trailData;

  const dispatch = useDispatch();
  const dimensions = useWindowDimension();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchBarHeight, setSearchBarHeight] = useState<number>(0);
  const [checked, setChecked] = useState(
    trailData?.status === "Active" ? true : false
  );
  const [showTypeModal, setShowModal] = useState({
    modal: Constant.GENERALKEYS.DISABLE,
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex: number) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  console.log(trailData.title, "trailData.title");
  const items =
    trailData?.other_images?.length > 0
      ? trailData.other_images.map((image: any, index: number) => ({
          src: image ? getCloudinaryOtherImageUrl(image) : imagePlaceholder,
          altText: `Slide ${index + 1}`,
          caption: `Slide ${index + 1}`,
          key: index + 1,
        }))
      : [
          {
            src: imagePlaceholder,
            altText: "No Image Available",
            caption: "No Image Available",
            key: 1,
          },
        ];

  const trackColors = ["red"];
  const tracks = [
    `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_NAME}/${process.env.REACT_APP_CLOUDNARY_GPX_FILES_SUBFLODER}/${trailData?.gpx_file}`,
  ];
  const mapRef = useRef<HTMLDivElement | null>(null);
  const mapInstanceRef = useRef<L.Map | null>(null); // Store map instance
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const onToggleSwitch = async () => {
    if (checked) {
      setShowModal({ modal: Constant.GENERALKEYS.DISABLE });
      setModal(true);
    } else {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await axios.patch(
          `${process.env.REACT_APP_API_BASE_URL}${TRAILS_STATUS}/${trailData?.id}`,
          { status: "Active" },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          setChecked(!checked);
          if (trailData) {
            trailData.status = "Active";
          }
          dispatch(
            showToast({
              show: true,
              message: response.data.message,
              type: "success",
            })
          );
        }
      } catch (error: any) {
        dispatch(
          showToast({
            show: true,
            message:
              error.response?.data?.message || "Failed to update trail status",
            type: "error",
          })
        );
      }
    }
  };
  const onRemoveTrail = () => {
    setShowModal({ modal: Constant.GENERALKEYS.DELETE });
    setModal(true);
  };

  useEffect(() => {
    setInterval(() => {
      setLoading(false);
    }, 3000);
  }, []);

  useEffect(() => {
    const searchBarHeightElement = document.getElementsByClassName(
      "pageTopbar"
    )[0] as HTMLElement;

    if (searchBarHeightElement) {
      setSearchBarHeight(searchBarHeightElement.offsetHeight);
    }
  }, []);

  const [modal, setModal] = useState(false);

  const cancelModal = () => {
    setModal(false);
  };
  const onDisableModal = async () => {
    setBtnLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}${TRAILS_STATUS}/${trailData?.id}`,
        { status: "Disabled" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        if (trailData) {
          trailData.status = "Disabled";
        }
        setChecked(false);
        setModal(false);
        dispatch(
          showToast({
            show: true,
            message: response.data.message,
            type: "success",
          })
        );
      }
    } catch (error: any) {
      dispatch(
        showToast({
          show: true,
          message:
            error.response?.data?.message || "Failed to update trail status",
          type: "error",
        })
      );
    } finally {
      setBtnLoading(false);
    }
  };
  const onRemoveModal = async () => {
    setBtnLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}${TRAILS_STATUS}/${trailData?.id}`,
        { status: "Deleted" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        dispatch(
          showToast({
            show: true,
            message: response.data.message,
            type: "success",
          })
        );
        setModal(false);
        navigate("/trails");
      }
    } catch (error: any) {
      dispatch(
        showToast({
          show: true,
          message: error.response?.data?.message || "Failed to delete trail",
          type: "error",
        })
      );
    } finally {
      setBtnLoading(false);
    }
  };

  const onGpxDownload = () => {
    setLoading(true);
    const gpxUrl = trailData?.gpx_file
      ? `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_NAME}/${process.env.REACT_APP_CLOUDNARY_GPX_FILES_SUBFLODER}/${trailData?.gpx_file}`
      : "";
    const link = document.createElement("a");
    link.href = gpxUrl;
    link.download = trailData?.gpx_file || "trail.gpx"; // Set the desired file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      dispatch(
        showToast({
          show: true,
          message: "GPX file downloaded successfully.",
          type: "success",
        })
      );
      setLoading(false);
    }, 2000);
  };

  const loadGPXData = async (url: string): Promise<string> => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch GPX data from ${url}`);
      }
      return await response.text();
    } catch (error) {
      console.error("Error loading GPX data:", error);
      throw error;
    }
  };

  const initializeMap = () => {
    if (mapInstanceRef.current) return;

    mapInstanceRef.current = L.map(mapRef.current as HTMLDivElement, {
      center: [55.745, -3.384],
      zoom: 14,
      fullscreenControl: true,
    });

    // Add base layer
    L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png",
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
        subdomains: "abcd",
        maxZoom: 19,
      }
    ).addTo(mapInstanceRef.current);

    // Add label overlay
    L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png",
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
        subdomains: "abcd",
        maxZoom: 19,
      }
    ).addTo(mapInstanceRef.current);

    // Add custom "Relocate" button
    const relocateButton = L.Control.extend({
      options: { position: "topleft" },
      onAdd: () => {
        const button = L.DomUtil.create("button", "leaflet-bar");
        button.innerHTML = "📍";
        button.style.backgroundColor = "white";
        button.style.border = "1px solid #ccc";
        button.style.borderRadius = "3px";

        L.DomEvent.on(button, "click", () => {
          relocateToCurrentLocation();
        });

        return button;
      },
    });

    mapInstanceRef.current.addControl(new relocateButton());
  };

  // Function to re-center to user's current location
  const markerRef = useRef<L.Marker | null>(null); // Store the marker reference
  mapInstanceRef.current?.eachLayer((layer) => {
    if (layer instanceof L.Marker) {
      mapInstanceRef.current?.removeLayer(layer);
    }
  });

  const relocateToCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;

          // Remove the previous marker if it exists
          if (markerRef.current) {
            mapInstanceRef.current?.removeLayer(markerRef.current);
          }

          // Create and add a new marker
          markerRef.current = L.marker([latitude, longitude]).addTo(
            mapInstanceRef.current!
          );

          // Optionally, re-center the map
          mapInstanceRef.current?.setView([latitude, longitude], 14);

          dispatch(
            showToast({
              show: true,
              message: "Map relocated to your current location.",
              type: "success",
            })
          );
        },
        (error) => {
          console.error("Error getting current location:", error);
          dispatch(
            showToast({
              show: true,
              message: "Failed to locate your position.",
              type: "error",
            })
          );
        }
      );
    } else {
      dispatch(
        showToast({
          show: true,
          message: "Geolocation is not supported by your browser.",
          type: "error",
        })
      );
    }
  };

  const addGPXTracksToMap = async () => {
    try {
      initializeMap();
      const map = mapInstanceRef.current;

      // Iterate over each GPX track and add it to the map
      for (let i = 0; i < tracks.length; i++) {
        const gpxData = await loadGPXData(tracks[i]);

        const gpxLayer = new L.GPX(gpxData, {
          polyline_options: {
            color: trackColors[i % trackColors.length],
            opacity: 1.0,
            weight: 4,
            lineCap: "round",
          },
        }).addTo(map!);

        // Adjust map view to center around the GPX track's bounds
        const gpxBounds = gpxLayer.getBounds();
        if (map) {
          map.fitBounds(gpxBounds, { padding: [50, 50] }); // Optional padding for better visibility
        }
      }
    } catch (error) {
      console.error("Error adding GPX tracks:", error);
      setError("Failed to load some or all GPX tracks.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageError = (e: any) => {
    e.target.src = imagePlaceholder; // Set the image to placeholder if it fails to load
  };

  useEffect(() => {
    addGPXTracksToMap();
  }, []);

  return (
    <>
      <Helmet>
        <title>{`${trailData.title} | Town of 1000 Trails Admin Panel`}</title>
        <meta
          name="description"
          content="View trail details and update information about the trail."
        />
      </Helmet>
      <div className="main-container container trailDetailPage">
        <div className="pageTopbar mb-4">
          <div className="leftPart">
            <CustomButton
              type="button"
              className="btn btn-transparent backBtn"
              onClick={() => {
                navigate("/trails", {
                  state: {
                    prevPage: "trailDetail",
                    trailId: trailData?.id,
                    currentPage: location.state?.currentPage,
                  },
                });
              }}
              title={t("BACK")}
              icon={<span className="icon icon-arrow-left me-2"></span>}
            />
          </div>
          <div className="rightPart">
            <div className="disableToggle">
              <CustomToggleButton
                checked={checked}
                id="trailToggle"
                onCheckChange={onToggleSwitch}
              />
              {checked ? t("ACTIVE") : t("DISABLE")}
            </div>
            <CustomButton
              type="button"
              className="btn  btn-outline-primary "
              onClick={(e) => {
                navigate(`/edit-trail/${trailData?.id}`, {
                  state: { mode: "edit", trailData: trailData },
                });
              }}
              title={t("EDIT")}
              icon={<span className="icon icon-Edit me-2"></span>}
            />
            <CustomButton
              type="button"
              className="btn  btn-outline-danger "
              onClick={onRemoveTrail}
              title={t("REMOVE_TRAIL")}
              icon={<span className="icon icon-Cancel me-2"></span>}
            />
          </div>
        </div>

        <div className="customScroll">
          <div className="trailContent">
            <div className="leftPart">
              <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
              >
                <CarouselIndicators
                  items={items}
                  activeIndex={activeIndex}
                  onClickHandler={goToIndex}
                />
                {items?.map((item: any) => (
                  <CarouselItem
                    key={item?.key}
                    onExiting={() => setAnimating(true)}
                    onExited={() => setAnimating(false)}
                  >
                    <img
                      src={item?.src ? item?.src : imagePlaceholder}
                      alt={item?.altText}
                      onError={handleImageError}
                    />
                  </CarouselItem>
                ))}
              </Carousel>
            </div>
            <div className="rightPart">
              <h1>{trailData?.title || "-"}</h1>
              <span className={!checked ? "disableBadge" : "activeBadge"}>
                {!checked ? t("DISABLED") : t("ACTIVE")}
              </span>
              <div className="trailDescription">
                {trailData?.description || "-"}
              </div>
              <div className="whiteCard">
                <div className="cardContent">
                  <div className="contentBtm">
                    <div className="dataWrapper">
                      <div className="label">{t("DIFFICULTY")}</div>
                      <div
                        className={`data ${
                          trailData?.difficulty?.toLowerCase() === "easy"
                            ? "cardTextGreen"
                            : trailData?.difficulty?.toLowerCase() ===
                              "intermediate"
                            ? "cardTextYellow"
                            : trailData?.difficulty?.toLowerCase() ===
                              "advanced"
                            ? "cardTextRed"
                            : "cardTextGray"
                        }`}
                      >
                        {trailData?.difficulty?.toUpperCase() || "-"}
                      </div>
                    </div>
                    <div className="dataWrapper">
                      <div className="label">{t("LENGTH")}</div>
                      <div className="data">
                        {trailData?.length || "-"} {t("MILES")}
                      </div>
                    </div>
                    <div className="dataWrapper">
                      <div className="label">{t("TOWNS")}</div>
                      <div className="data">{trailData?.towns || "N/A"}</div>
                    </div>
                    <div className="dataWrapper">
                      <div className="label">{t("TOTAL_ASCENT_(M)")}</div>
                      <div className="data">{trailData?.ascent || "-"}</div>
                    </div>
                    <div className="dataWrapper">
                      <div className="label">{t("AVERAGE_TIME")}</div>
                      <div className="data">
                        {trailData?.average_time_hours || "0"} {t("HOURS")}{" "}
                        {trailData?.average_time_minutes || "0"} {t("MINUTES")}
                      </div>
                    </div>
                    <div className="dataWrapper">
                      <div className="label">{t("GPX_START_LAT")}</div>
                      <div className="data">
                        {trailData?.start_latitude || "-"}
                      </div>
                    </div>
                    <div className="dataWrapper">
                      <div className="label">{t("GPX_START_LNG")}</div>
                      <div className="data">
                        {trailData?.start_longitude || "-"}
                      </div>
                    </div>
                    <CustomButton
                      type="button"
                      className="btn btn-danger"
                      onClick={onGpxDownload}
                      disabled={trailData.gpx_file === "" ? true : false}
                      loading={loading}
                      title={t("DOWNLOAD_GPX")}
                      icon={<span className="icon icon-download me-2"></span>}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div ref={mapRef} style={{ width: "100%", height: "456px" }} />
        </div>

        <Modal
          isOpen={modal}
          toggle={cancelModal}
          className="mainModal"
          centered
        >
          <ModalHeader toggle={cancelModal}>
            {" "}
            {showTypeModal?.modal === Constant.GENERALKEYS.DISABLE
              ? t("DISABLE_TRAIL")
              : t("REMOVE_TRAIL")}
          </ModalHeader>
          <ModalBody>
            {showTypeModal?.modal === Constant.GENERALKEYS.DISABLE
              ? t("DISABLE_TRAIL_DESCRIPTION")
              : t("REMOVE_TRAIL_DESCRIPTION")}
          </ModalBody>
          <ModalFooter>
            <CustomButton
              type="button"
              loading={btnLoading}
              className="btn btn-danger text-white"
              onClick={
                showTypeModal.modal === Constant.GENERALKEYS.DISABLE
                  ? onDisableModal
                  : onRemoveModal
              }
              title={
                showTypeModal.modal === Constant.GENERALKEYS.DISABLE
                  ? t("DISABLE")
                  : t("REMOVE")
              }
            />
            <CustomButton
              type="button"
              className="btn btn-transparent"
              onClick={cancelModal}
              title={t("CANCEL")}
            />
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default TrailDetail;
